import { createContext, useContext } from "react";
import type { Workspace, WorkspaceUsage } from "@rapid/types/workspace";

export interface WorkspaceContextValue {
    currentWorkspace: Workspace | null;
    currentWorkspaceUsage: WorkspaceUsage | null;
    apiKey: string | null;
    switchWorkspace: (id: string) => void;
}

export const WorkspaceContext = createContext<WorkspaceContextValue | null>(null);

export function useWorkspaceContext() {
    const ctx = useContext(WorkspaceContext);
    if (!ctx) throw new Error("useWorkspaceContext must be used within WorkspaceProvider");
    return ctx;
}
